import { IconLoader } from '@tabler/icons-react';

export default function LoadingFallback({ message = '...Loading' }: { message: string }) {
  return (
    <div className="w-full flex items-center justify-center p-4 space-x-2">
      <IconLoader className="animate-spin w-5 h-5  text-blue-500" />
      <span className="text-gray-600">{message}</span>
    </div>
  );
}
